import {$themeBreakpoints} from '@themeConfig'

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    user: null
  },
  getters: {
    currentBreakPoint: state => {
      const {windowWidth} = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
    // permissions: state => state.user?.permissions,
    // roles: state => state.user?.roles,
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
    SET_USER(state, val) {
      state.user = val
    }
  },
  actions: {
    setUser({dispatch, commit}, user){

      if (user){
        // dispatch('notification/getNotifications', {}, { root: true })

        this._vm.$ability.update(user.permissions.map(i => ({
          action: i,
          subject: 'all'
        })));

      }
      commit('SET_USER', user)
    },
  },
}
